/**
 * Centralised API service for CanDo Payments.
 *
 * Usage:
 *   import { api } from "@/services/api";
 *   const data = await api.get("/ecologi");
 *   await api.post("/leads", { first_name: "Gary", ... });
 *
 * All endpoints are prefixed with REACT_APP_BACKEND_URL/api automatically.
 * Handles JSON parsing and error responses consistently.
 */
import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

// Response interceptor — unwrap data, handle errors consistently
client.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const detail = error.response?.data?.detail;
    // FastAPI 422s carry a list of {loc, msg}; surface the first readable msg.
    const message =
      (Array.isArray(detail) ? detail[0]?.msg?.replace(/^Value error, /, "") : detail) ||
      error.message ||
      "Something went wrong";
    const err = new Error(message);
    err.status = error.response?.status;
    return Promise.reject(err);
  }
);

export const api = {
  get: (path, params) => client.get(path, { params }),
  post: (path, data) => client.post(path, data),
};

export default api;
